<template>
   <div>




<!--Start home-page-container -->
  <div class="home-page-container" >
    

    <!-- <div class="" vs-lg="12" vs-sm="4" vs-xs="6"  vs-type="flex"> <img src="background-image" alt="">     </div>   -->
    <!-- class="backgroundimage" -->
    <!-- <img src="../assets/images/photo-2.png" > -->

    <!--  -->
<!-- في template الـ Home -->







    <!--  -->
    <div class="home-welcome">
      <section class="home-intro-row" aria-labelledby="home-title">
        <div class="home-intro-copy">
          <span class="home-kicker">CONNECTED CARE, WHEREVER YOU ARE</span>
          <h1 id="home-title">Your medical &amp; wellness journey <em>starts here.</em></h1>
          <p class="home-lead">Connecting patients to high quality medical care, anywhere in the world.</p>
          <ul class="home-trust-list">
            <li><feather-icon icon="CheckCircleIcon" /> A verified network of doctors</li>
            <li><feather-icon icon="VideoIcon" /> In-person and online visits</li>
            <li><feather-icon icon="GlobeIcon" /> Medical and wellness destinations</li>
          </ul>
        </div>
        <div class="home-intro-media">
          <img class="home-intro-image" src="../assets/images/home-hero-enhanced.png" alt="Medical care and wellness destinations" width="1891" height="831" fetchpriority="high" />
          <div class="home-image-note"><feather-icon icon="HeartIcon" /><span>Explore your next step towards better health</span></div>
        </div>
      </section>
      <section class="home-search-placement" aria-label="Find medical care">
        <MainSystemSearch />
      </section>
    </div>

    <!--  -->

    <!-- <img src="../assets/images/photo-2.png" style=" background-size: cover;
  background-repeat: round;
  background-attachment: local;" > -->

    <!-- <img src="../assets/images/photo-2.png" > -->

    <!-- <div class="aaa"> <img src="../assets/images/4.png" alt="">
          
        </div> -->

    <div>
      <vs-row vs-justify="center">
        <vs-row
          vs-justify="center"
          vs-align="center"
          vs-lg="12"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-card>
            <div class="back-grewond2">
              <vs-row vs-justify="flex-center" vs-lg="12" vs-sm="4" vs-xs="12">
                <vs-row vs-lg="12" vs-sm="4" vs-xs="12">
                  <vs-col
                    style="padding: 1%"
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <vs-button
                      color="success"
                      color-text="rgb(50,50,50)"
                      type="border"
                      size="large"
                      href="/SurgeryAndTreatment"
                    >
                      <span style="font-size: 90%">Medical Procedures</span>
                    </vs-button>
                  </vs-col>
                  <vs-col
                    style="padding: 4%"
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <vs-button
                      color="success"
                      color-text="rgb(50,50,50)"
                      type="border"
                      size="large"
                      href="/AppointmentSearch"
                    >
                      <span style="font-size: 90%"> Online Appointments</span>
                    </vs-button>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <vs-button
                      color="success"
                      color-text="rgb(50,50,50)"
                      type="border"
                      size="large"
                      href="/OurPackages"
                      >Wellness Packages</vs-button
                    >
                  </vs-col>
                </vs-row>
                <vs-row
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-md="12"
                  vs-sm="12"
                  vs-xs="12"
                  style="padding: 2%"
                >
                  <h1 style="color: aliceblue">TOP DESTINATIONS</h1>
                </vs-row>
                <vs-row
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-md="12"
                  vs-sm="12"
                  vs-xs="12"
                  style="padding: 2%"
                >
                  <vs-row
                    vs-lg="12"
                    vs-sm="4"
                    vs-xs="12"
                    vs-justify="center"
                    style="text-align-last: center"
                  >
                  <!-- Start Countru -->
                   <!-- *********************************************** -->
<vs-row
  vs-lg="12"
  vs-sm="4"
  vs-xs="2"
  vs-justify="center"
  style="text-align-last: center; padding: 1%"
>
  <!-- 1. UAE  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(74)" class="all-mig" src="../assets/images/uea.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">UAE</h5>
  </vs-col>

  <!-- 2. Egypt  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(7)" class="all-mig" src="../assets/images/Egypt.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Egypt</h5>
  </vs-col>

  <!-- 3. Greece  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(50)" class="all-mig" src="../assets/images/Greece.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Greece</h5>
  </vs-col>

  <!-- 4. Spain  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(4)" class="all-mig" src="../assets/images/Spain.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Spain</h5>
  </vs-col>

  <!-- 5. Germany  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(3)" class="all-mig" src="../assets/images/germin-flag.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Germany</h5>
  </vs-col>

  <!-- 6. USA  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(39)" class="all-mig" src="https://doclinia.com/wp-content/uploads/2024/04/Flag_of_the_United_States_DoS_ECA_Color_Standard.svg-150x150.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">USA</h5>
  </vs-col>

  <!-- 7. Thailand -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(528)" class="all-mig" src="../assets/images/Thailand.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Thailand</h5>
  </vs-col>

  <!-- 8. Turkey (ID: 1) -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(1)" class="all-mig" src="../assets/images/Turkey.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Turkey</h5>
  </vs-col>

  <!-- 9. India -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(29)" class="all-mig" src="../assets/images/India.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">India</h5>
  </vs-col>

  <!-- 10. Czech Republic  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(559)" class="all-mig" src="../assets/images/Czech.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Czech Republic</h5>
  </vs-col>

  <!-- 11. Jordan  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(423)" class="all-mig" src="../assets/images/Jordan.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Jordan</h5>
  </vs-col>
</vs-row>

<!-- Second row (remaining countries from 12 to 21) -->
 <vs-row
  vs-lg="12"
  vs-sm="4"
  vs-xs="2"
  vs-justify="center"
  style="text-align-last: center; padding: 1%"
>
  <!-- 12. Switzerland  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(359)" class="all-mig" src="../assets/images/Switzerland.png"  alt="" />
    <h5 style="color: aliceblue; align-content: center">Switzerland</h5>
  </vs-col>

  <!-- 13. UK  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(539)" class="all-mig" src="../assets/images/UK.webp"  alt="" />
    <h5 style="color: aliceblue; align-content: center">UK</h5>
  </vs-col>

  <!-- 14. Saudi Arabia (ID: 24) -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(560)" class="all-mig" src="../assets/images/SaudiArabia.png"  alt="" />
    <h5 style="color: aliceblue; align-content: center">Saudi Arabia</h5>
  </vs-col>

  <!-- 15. Georgia  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(390)" class="all-mig" src="../assets/images/Georgia.webp"  alt="" />
    <h5 style="color: aliceblue; align-content: center">Georgia</h5>
  </vs-col>

  <!-- 16. Italy  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(420)" class="all-mig" src="../assets/images/Italy.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Italy</h5>
  </vs-col>

  <!-- 17. Korea (ID: 432) -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(432)" class="all-mig" src="../assets/images/Korea.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Korea</h5>
  </vs-col>

  <!-- 18. Serbia  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(500)" class="all-mig"  src="../assets/images/Serbia.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Serbia</h5>
  </vs-col>

  <!-- 19. South Africa  -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(556)" class="all-mig"  src="../assets/images/SouthAfrica.webp" alt="" />
    <h5 style="color: aliceblue; align-content: center">South Africa</h5>
  </vs-col>

  <!-- 20. Brazil -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(347)" class="all-mig" src="../assets/images/Brazil.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Brazil</h5>
  </vs-col>

  <!-- 21. Poland (ID: 3) -->
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="2" style="display: block;">
    <img @click="goToCountryPackages(2)" class="all-mig" src="../assets/images/Poland.png" alt="" />
    <h5 style="color: aliceblue; align-content: center">Poland</h5>
  </vs-col>
</vs-row>
                   <!-- *********************************************** -->
                  </vs-row>
                  <!-- End Cuntry -->
                </vs-row>
              </vs-row>
            </div>
          </vs-card>
        </vs-row>
      </vs-row>
    </div>

    <!-- 3line -->
    <div>
      <vs-row vs-justify="center">
        <vs-row
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="12"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-card>
            <div class="back-grewond2">
              <vs-row vs-justify="flex-center" vs-lg="12" vs-sm="4" vs-xs="12">
                <vs-row vs-lg="12" vs-sm="4" vs-xs="12">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="12"
                  >
                  </vs-col>
                  <vs-col
                    style="padding: 2%"
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <h1 style="color: #00c425">WHY</h1>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="12"
                  >
                  </vs-col>
                </vs-row>
                <vs-row
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-md="12"
                  vs-sm="12"
                  vs-xs="12"
                >
                  <h1 style="color: aliceblue">DOCLINIA?</h1>
                </vs-row>
                <vs-row
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="3"
                  vs-md="12"
                  vs-sm="12"
                  vs-xs="12"
                  class="con-vs-slider"
                  ><vs-slider color="success"></vs-slider
                ></vs-row>
                <vs-row
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-md="12"
                  vs-sm="12"
                  vs-xs="12"
                >
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <vs-row vs-justify="center">
                      <vs-col
                        type="flex"
                        vs-justify="center"
                        vs-align="center"
                        vs-w="8"
                      >
                        <vs-card style="border-radius: 10% 9% 10% 9%">
                          <vs-row
                            vs-type="flex"
                            vs-justify="center"
                            vs-align="center"
                            vs-lg="4"
                            vs-sm="4"
                            vs-xs="12"
                          >
                            <img
                              style="width: 20%; text-align: center"
                              src="../assets/images/icon123456.png"
                              alt=""
                            />

                            <h1
                              style="
                                color: #00c425;
                                text-align: center;
                                padding: 4%;
                              "
                            >
                              Verified, Trusted Global Providers
                            </h1>
                            <h4
                              style="
                                color: #004477;
                                text-align: center;
                                padding: 4%;
                              "
                            >
                              Exceptional Expertise, Distinguish Reputation
                            </h4>
                          </vs-row>
                        </vs-card>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                  <!--  -->
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <vs-row vs-justify="center">
                      <vs-col
                        type="flex"
                        vs-justify="center"
                        vs-align="center"
                        vs-w="8"
                      >
                        <vs-card style="border-radius: 10% 9% 10% 9%">
                          <vs-row
                            vs-type="flex"
                            vs-justify="center"
                            vs-align="center"
                            vs-lg="4"
                            vs-sm="4"
                            vs-xs="12"
                          >
                            <img
                              style="width: 20%; text-align: center"
                              src="../assets/images/icon12345.png"
                              alt=""
                            />

                            <h1
                              style="
                                color: #00c425;
                                text-align: center;
                                padding: 4%;
                              "
                            >
                              Empowering Personal Care
                            </h1>
                            <h4
                              style="
                                color: #004477;
                                text-align: center;
                                padding: 4%;
                              "
                            >
                              Tailored Solutions, Informed Decisions
                            </h4>
                          </vs-row>
                        </vs-card>
                      </vs-col>
                    </vs-row>
                  </vs-col>

                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <vs-row vs-justify="center">
                      <vs-col
                        type="flex"
                        vs-justify="center"
                        vs-align="center"
                        vs-w="8"
                      >
                        <vs-card style="border-radius: 10% 9% 10% 9%">
                          <vs-row
                            vs-type="flex"
                            vs-justify="center"
                            vs-align="center"
                            vs-lg="4"
                            vs-sm="4"
                            vs-xs="12"
                          >
                            <img
                              style="width: 20%; text-align: center"
                              src="../assets/images/icon123.png"
                              alt=""
                            />

                            <h1
                              style="
                                color: #00c425;
                                text-align: center;
                                padding: 5%;
                              "
                            >
                              Stress-Free Journey
                            </h1>
                            <h4
                              style="
                                color: #004477;
                                text-align: center;
                                padding: 7%;
                              "
                            >
                              Comprehensive Support, Peace of Mind Guaranteed
                            </h4>
                          </vs-row>
                        </vs-card>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
              </vs-row>
            </div>
          </vs-card>
        </vs-row>
      </vs-row>
    </div>

    <!-- ============================================= -->
    <!-- DOCLINIA GOOGLE REVIEWS -->
    <!-- ============================================= -->
   <section class="google-reviews-section">
      <div class="google-reviews-inner">

        <!-- Loading state -->
        <div
          v-if="googleReviewsLoading"
          class="google-reviews-loading"
        >
          <div class="google-loading-spinner"></div>
          <p>Loading Google reviews...</p>
        </div>

        <!-- Reviews content -->
        <template v-else-if="googleReviews">
          <div class="google-reviews-header">
            <div class="google-reviews-heading">
              <span class="google-reviews-eyebrow">
                Patient Experiences
              </span>

              <h2>
                What People Say About Doclinia
              </h2>

              <p>
                Real experiences shared by our clients on Google.
              </p>
            </div>

            <!-- Overall Google rating -->
            <a
              class="google-overall-card"
              :href="googleReviews.GoogleMapsUrl || docliniaGoogleMapsUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div class="google-brand-row">
                <span class="google-brand-letter">G</span>
                <span class="google-brand-name">Google Reviews</span>
              </div>

              <div
                class="google-overall-rating-row"
                v-if="hasGoogleOverallRating"
              >
                <span class="google-overall-rating-number">
                  {{ Number(googleReviews.Rating).toFixed(1) }}
                </span>

                <star-rating
                  :rating="Number(googleReviews.Rating)"
                  :star-size="25"
                  :increment="0.1"
                  :read-only="true"
                  :show-rating="false"
                  :padding="2"
                ></star-rating>
              </div>

              <div
                class="google-review-count"
                v-if="googleReviews.UserRatingCount !== null && googleReviews.UserRatingCount !== undefined"
              >
                Based on
                {{ Number(googleReviews.UserRatingCount).toLocaleString() }}
                Google reviews
              </div>

              <span class="google-overall-link-text">
                View on Google
              </span>
            </a>
          </div>

          <!-- Review cards -->
          <div
            class="google-reviews-grid"
            v-if="googleReviews.Reviews && googleReviews.Reviews.length > 0"
          >
            <article
              class="google-review-card"
              v-for="(review, reviewIndex) in googleReviews.Reviews"
              :key="reviewIndex"
            >
              <div class="google-review-top">
                <div class="google-review-author">
                  <a
                    v-if="review.AuthorGoogleUrl"
                    :href="review.AuthorGoogleUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="google-review-author-link"
                  >
                    <img
                      v-if="review.AuthorPhotoUrl"
                      :src="review.AuthorPhotoUrl"
                      class="google-review-author-photo"
                      :alt="review.AuthorName || 'Google reviewer'"
                    />

                    <div
                      v-else
                      class="google-review-author-placeholder"
                    >
                      {{ getReviewerInitial(review.AuthorName) }}
                    </div>
                  </a>

                  <template v-else>
                    <img
                      v-if="review.AuthorPhotoUrl"
                      :src="review.AuthorPhotoUrl"
                      class="google-review-author-photo"
                      :alt="review.AuthorName || 'Google reviewer'"
                    />

                    <div
                      v-else
                      class="google-review-author-placeholder"
                    >
                      {{ getReviewerInitial(review.AuthorName) }}
                    </div>
                  </template>

                  <div class="google-review-author-info">
                    <h4>
                      {{ review.AuthorName || 'Google User' }}
                    </h4>
                    <span v-if="review.RelativeTime">
                      {{ review.RelativeTime }}
                    </span>
                  </div>
                </div>

                <span class="google-review-source">Google</span>
              </div>

              <div class="google-review-stars">
                <star-rating
                  :rating="Number(review.Rating || 0)"
                  :star-size="18"
                  :increment="0.1"
                  :read-only="true"
                  :show-rating="false"
                  :padding="1"
                ></star-rating>
              </div>

              <p
                class="google-review-text"
                v-if="review.Text"
              >
                {{ truncateGoogleReview(review.Text) }}
              </p>

              <a
                v-if="review.GoogleMapsUrl"
                :href="review.GoogleMapsUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="google-review-read-link"
              >
                Read on Google
                <span aria-hidden="true">→</span>
              </a>
            </article>
          </div>

          <!-- When Google returns rating but no review text -->
          <div
            class="google-no-review-cards"
            v-else
          >
            <p>
              View our latest ratings and reviews directly on Google.
            </p>
          </div>

          <div class="google-reviews-footer">
            <a
              :href="googleReviews.GoogleMapsUrl || docliniaGoogleMapsUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="google-reviews-button"
            >
              View All Reviews on Google
            </a>
          </div>
        </template>
      </div>
    </section>

    <vs-row vs-lg="12" vs-sm="4" vs-xs="12">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="4"
        vs-sm="4"
        vs-xs="12"
      >
      </vs-col>
      <vs-col
        style="padding: 2%"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="4"
        vs-sm="4"
        vs-xs="12"
      >
        <h1 style="color: #124179; font-size: -webkit-xxx-large">
          Our Partners
        </h1>
      </vs-col>
    </vs-row>

    <!-- Start HAndel Hospital Clickable  -->



<vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-md="12" vs-sm="12" vs-xs="12">
    <!-- 
  <h3 style="padding-left: 5%; color: black;">
    Doclinia takes pride in its collaboration with esteemed partners, uniting elite healthcare providers to redefine and elevate global standards in medical tourism.
  </h3>
  -->
</vs-row>

<vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-md="12" vs-sm="12" vs-xs="12" style="padding: 2%">
<!-- First row  -->
  <vs-row vs-lg="10" vs-sm="4" vs-xs="12" vs-justify="center" style="text-align-last: center; padding: 2%">
    <!-- 1. Acıbadem -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" style="display: block">
      <img @click="goToHospitalPackages(1105)" class="shadow-lg shadow-indigo-500/40" style="width: 75%; cursor: pointer;" src="../assets/images/Screenshot-2023-12-23-142209-e17.png" alt="" />
      <!-- <br /><br />
      <h4 style="color: black; align-content: center">Acıbadem 24 Hospitals in Turkey</h4>
      <br /><br /><br /> -->
    </vs-col>

    <!-- 2. Dr. Sulaiman AlHabib -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" style="display: block">
      <img @click="goToHospitalPackages(1060)" class="shadow-lg shadow-indigo-500/40" style="width: 75%; cursor: pointer;" src="../assets/images/Sulaiman.png" alt="" />
      <!-- <br /><br />
      <h3 style="color: black; align-content: center">Dr. Sulaiman AlHabib Dubai</h3>
      <br /><br /><br /> -->
    </vs-col>

    <!-- 3. Hayat Hospital -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" style="display: block">
      <img @click="goToHospitalPackages(1063)" class="shadow-lg shadow-indigo-500/40" style="width: 75%; cursor: pointer;" src="../assets/images/Hayat.png" alt="" />
      <!-- <br /><br />
      <h3 style="color: black; align-content: center">Hayat Hospital Bursa</h3>
      <br /><br /><br /> -->
    </vs-col>

    <!-- 4. Kamalaya -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" style="display: block">
      <img @click="goToHospitalPackages(1111)" class="shadow-lg shadow-indigo-500/20" style="width: 75%; cursor: pointer;" src="../assets/images/Kamalaya.png" alt="" />
      <!-- <br /><br />
      <h3 style="color: black; align-content: center">Kamalaya Thailand</h3>
      <br /><br /><br /> -->
    </vs-col>

    <!-- 5. Quironsalud -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" style="display: block">
      <img @click="goToHospitalPackages(1029)" class="shadow-lg shadow-indigo-500/40" style="width: 75%; cursor: pointer;" src="../assets/images/Quironsalud.png" alt="" />
      <!-- <br /><br />
      <h3 style="color: black; align-content: center">Quironsalud Hospitals Spain</h3>
      <br /><br /><br /> -->
    </vs-col>
  </vs-row>

  <!-- Second row -->
  <vs-row vs-lg="10" vs-sm="4" vs-xs="12" vs-justify="center" style="text-align-last: center; padding: 2%">
    <!-- 6. Dr. Faris -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" style="display: block">
      <img @click="goToHospitalPackages(1051)" class="shadow-lg shadow-indigo-500/40" style="width: 75%; cursor: pointer;" src="../assets/images/Medical.png" alt="" />
      <!-- <br /><br />
      <h4 style="color: black; align-content: center">Dr. Faris Medical Centre Cairo</h4>
      <br /><br /><br /> -->
    </vs-col>

    <!-- 7. Nicolas & Asp -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" style="display: block">
      <img @click="goToHospitalPackages(1039)" class="shadow-lg shadow-indigo-500/40" style="width: 75%; cursor: pointer;" src="../assets/images/Nicolas.png" alt="" />
      <!-- <br /><br />
      <h4 style="color: black; align-content: center">Drs. Nicolas & Asp Centers Dubai</h4>
      <br /><br /><br /> -->
    </vs-col>

    <!-- 9. Palasiet -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" style="display: block">
      <img @click="goToHospitalPackages(1081)" class="shadow-lg shadow-indigo-500/20" style="width: 75%; cursor: pointer;" src="../assets/images/Palasiet.png" alt="" />
      <!-- <br /><br />
      <h3 style="color: black; align-content: center">Palasiet Spa Spain</h3>
      <br /><br /><br /> -->
    </vs-col>

    <!-- 10. Abu Dhabi Stem Cells -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" style="display: block">
      <img @click="goToHospitalPackages(1080)" class="shadow-lg shadow-indigo-500/40" style="width: 75%; cursor: pointer;" src="../assets/images/AbuDhabi.png" alt="" />
      <!-- <br /><br />
      <h5 style="color: black; align-content: center">Abu Dhabi Stem Cells Centre Abu Dhabi</h5>
      <br /><br /><br /> -->
    </vs-col>
  </vs-row>

    <!-- Third row -->
  <vs-row vs-lg="10" vs-sm="4" vs-xs="12" vs-justify="center" style="text-align-last: center">
    <!-- 11. Teknon -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" style="display: block">
      <img @click="goToHospitalPackages(1026)" class="shadow-lg shadow-indigo-500/40" style="width: 75%; cursor: pointer;" src="../assets/images/Teknon.png" alt="" />
      <!-- <br /><br />
      <h4 style="color: black; align-content: center">Centro Medico Teknon Spain</h4>
      <br /><br /><br /> -->
    </vs-col>

    <!-- 13. Fakeeh -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" style="display: block">
      <img @click="goToHospitalPackages(1096)" class="shadow-lg shadow-indigo-500/40" style="width: 75%; cursor: pointer;" src="../assets/images/Fakeeh.png" alt="" />
      <!-- <br /><br />
      <h4 style="color: black; align-content: center">Fakeeh University Hospital Dubai</h4>
      <br /><br /><br /> -->
    </vs-col>
  </vs-row>
</vs-row>

        <!-- End HAndel Hospital Clickable  -->

<!-- foter -->
<!-- <div class="shared-footer-wrapper">
  <Footer></Footer>
</div> -->
<!-- foter -->
  
    <!-- foter -->
    <div class="shared-footer-wrapper">
    <vs-row vs-justify="center">
      <vs-row
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="4"
        vs-xs="12"
      >
        <vs-card class="footer-card-custom">
          <div class="back-grewond2">
            <vs-row vs-justify="center" vs-lg="12" vs-sm="4" vs-xs="12" class="footer-row-main">
              
              <!-- =========================
                   COLUMN 1: About & Contact
              ========================= -->
              <vs-col vs-lg="4" vs-sm="4" vs-xs="12" class="footer-col-custom">
                <div class="footer-content-box">
                  
                  <img class="footer-logo" src="../assets/images/doclnia.png" alt="Doclinia" />

                  <div class="brand-text">
                    <p>Brand of Cure Journey Portal</p>
                    <a href="https://www.cure-journey.com" target="_blank" rel="noopener">
                      www.cure-journey.com
                    </a>
                  </div>

                  <!-- Contact Items -->
                  <div class="contact-area">
                    <a class="contact-item" href="tel:+971501539880">
                      <img src="../assets/images/call.png" alt="Phone" />
                      <span>+971501539880</span>
                    </a>

                    <a class="contact-item" href="https://api.whatsapp.com/send/?phone=201222246224" target="_blank" rel="noopener">
                      <img src="../assets/images/wahts.png" alt="WhatsApp" />
                      <span>+201222246224</span>
                    </a>
                  </div>

                  <!-- Privacy Policy -->
                  <div class="footer-section-title">
                    <h3>PRIVACY POLICY</h3>
                    <span class="green-line"></span>
                  </div>

                  <ul class="footer-links">
                    <li>
                      <a href="/pages/termsconditions">
                        <span class="arrow">›</span>
                        Terms &amp; Conditions
                      </a>
                    </li>
                  </ul>

                </div>
              </vs-col>

              <!-- =========================
                   COLUMN 2: Collaborate & Payments
              ========================= -->
              <vs-col vs-lg="4" vs-sm="4" vs-xs="12" class="footer-col-custom">
                <div class="footer-content-box">
                  
                  <div class="footer-section-title">
                    <h3>COLLABORATE</h3>
                    <span class="green-line"></span>
                  </div>

                  <ul class="footer-links">
                    <li>
                      <a href="/pages/Doctors/">
                        <span class="arrow">›</span>
                        Doctors
                      </a>
                    </li>
                    <li>
                      <a href="/pages/Doctors/">
                        <span class="arrow">›</span>
                        Hospitals
                      </a>
                    </li>
                    <li>
                      <a href="/pages/Doctors/">
                        <span class="arrow">›</span>
                        Strategic Alliances
                      </a>
                    </li>
                    <li>
                      <a href="/pages/JoinOurTeam/">
                        <span class="arrow">›</span>
                        Join Our Team
                      </a>
                    </li>
                  </ul>

                      <p class="payment-text">
                    We accept online payments using VISA and MasterCard credit/debit card in USD
                  </p>

                  <!-- Payment Logos -->
                  <div class="payment-logos-wrapper">
                    <img class="payment-img" src="../assets/images/visa2.png" alt="Visa 2" />
                    <img class="payment-img" src="../assets/images/visa3.png" alt="Visa 3" />
                    <img class="payment-img" src="../assets/images/visa4.png" alt="Visa 4" />
                  </div>

                </div>
              </vs-col>

              <!-- =========================
                   COLUMN 3: Patient Care & Social
              ========================= -->
              <vs-col vs-lg="4" vs-sm="4" vs-xs="12" class="footer-col-custom">
                <div class="footer-content-box">
                  
                  <div class="footer-section-title">
                    <h3>PATIENT CARE</h3>
                    <span class="green-line"></span>
                  </div>

                  <ul class="footer-links">
                    <li>
                      <a href="/pages/Contact-us">
                        <span class="arrow">›</span>
                        Contact Us
                      </a>
                    </li>
                    <li>
                      <a href="/FAQQQ">
                        <span class="arrow">›</span>
                        FAQ
                      </a>
                    </li>
                    <li>
                      <a href="/patientwaiverr">
                        <span class="arrow">›</span>
                        Patient Waiver
                      </a>
                    </li>
                  </ul>

              

                  <!-- Follow Us -->
                   <div class="follow-us">
                       <h3>Follow Us</h3>
                   </div>
                <div class="social-icons">

              <a
                href="https://www.facebook.com/Doclinia"
                target="_blank"
                rel="noopener"
                aria-label="Facebook"
              >
                <img
                  src="../assets/images/face1.png"
                  alt="Facebook"
                />
              </a>


              <a
                href="https://www.instagram.com/doclinia.uae/"
                target="_blank"
                rel="noopener"
                aria-label="Instagram"
              >
                <img
                  src="../assets/images/instgram.png"
                  alt="Instagram"
                />
              </a>


              <a
                href="https://www.linkedin.com/company/doclinia/"
                target="_blank"
                rel="noopener"
                aria-label="LinkedIn"
              >
                <img
                  src="../assets/images/linked.png"
                  alt="LinkedIn"
                />
              </a>


              <a
                href="https://www.tiktok.com/@doclinia"
                target="_blank"
                rel="noopener"
                aria-label="TikTok"
              >
                <img
                  src="../assets/images/tiktok.png"
                  alt="TikTok"
                />
              </a>

              <a
                href="https://www.youtube.com/@doclinia"
                target="_blank"
                rel="noopener"
                aria-label="YouTube"
              >
            <img
  src="../assets/images/youtube.png"
  alt="YouTube"
style="width: 35px; height: 35px;"
  />
              </a>
   


            </div>

                </div>
              </vs-col>

            </vs-row>
          </div>
        </vs-card>
      </vs-row>
    </vs-row>
  </div>
    <!-- foter -->

  </div>
 <!--End home-page-container -->


</div>

</template>
<script>
import { domain } from "@/gloabelConstant.js";
import StarRating from "vue-star-rating";
import moduleDoctor from "@/store/doctor/moduleDoctor.js";
import imageLazy from "@/components/image_lazy.vue";
import Footer from "../components/footer/Footer.vue";
import axios from "@/axios.js";
import MainSystemSearch from "@/views/pages/MainSystemSearch.vue";

export default {
  data() {
    return {
      rating: 0,
      PhotoPath: "",
      baseURL: domain,
      googleReviews: true,
      googleReviewsLoading: true,
      googleReviewsError: null,
      docliniaGoogleMapsUrl:
        "https://www.google.com/maps?q=Doclinia&ftid=0x4765528381df6ee7:0x19b07d9b446a15e2",
      model:{
         DoctorID:0,
        PatientReserviedSessionID:0,
        Comment:""
      },
      doctor: {
        
      }
    };
  },
  components: {
    StarRating,Footer,
    imageLazy,
    MainSystemSearch
  },
  props: {
    DoctorRate: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    hasGoogleOverallRating() {
      return (
        this.googleReviews &&
        this.googleReviews.Rating !== null &&
        this.googleReviews.Rating !== undefined &&
        !isNaN(Number(this.googleReviews.Rating))
      );
    }
  },
  methods: {

async loadGoogleReviews() {
  this.googleReviewsLoading = true;
  this.googleReviewsError = null;
  this.googleReviews = null;

  try {

    const apiBaseUrl =
      domain.replace(/\/$/, "");

    const response =
      await axios.get(
        `${apiBaseUrl}/api/Common/GetDocliniaGoogleReviews`
      );

    console.log(
      "Google Reviews Response:",
      response.data
    );

    let data =
      response.data;

    if (typeof data === "string") {
      data =
        JSON.parse(data);
    }

    if (data && data.Data) {
      data = data.Data;
    }
    else if (data && data.data) {
      data = data.data;
    }

    this.googleReviews =
      data;

  }
  catch (error) {

    console.error(
      "GetDocliniaGoogleReviews ERROR:",
      error
    );

    this.googleReviewsError =
      error.response &&
      error.response.data &&
      error.response.data.Message
        ? error.response.data.Message
        : error.message;

    this.googleReviews = null;
  }
  finally {

    this.googleReviewsLoading =
      false;

  }
},
    truncateGoogleReview(text) {
      if (!text) return "";

      const maxLength = 240;

      if (text.length <= maxLength) {
        return text;
      }

      return text.substring(0, maxLength).trim() + "...";
    },

    getReviewerInitial(authorName) {
      if (!authorName) return "G";

      return authorName
        .trim()
        .charAt(0)
        .toUpperCase();
    },

  goToCountryPackages(countryId) {
      this.$router.push({ 
        name: 'generalSearch', 
        query: { countryId: countryId } 
      });
      },

goToHospitalPackages(hospitalId) {
    this.$router.push({ 
      name: 'SurgeryAndTreatment',
      query: { hospitalId: hospitalId } 
    });
  },
   goToMainSearch() {
  this.$router.push({ name: "MainSystemSearch" });
},
  },
  mounted() {
    console.log(this.data);
  },
  created() {
    this.loadGoogleReviews();

    debugger
    this.model.Comment = "";
    debugger;
    if (!moduleDoctor.isRegistered) {
      this.$store.registerModule("DoctorList", moduleDoctor);
      moduleDoctor.isRegistered = true;
    }

      if(this.$route.params.DoctorID)
      {
        this.model.DoctorID = this.$route.params.DoctorID;
        this.model.PatientReserviedSessionID = this.$route.params.PatientReserviedSessionID;
      }

      else if(this.DoctorRate.DoctorID)
      {
          this.model.DoctorID = this.DoctorRate.DoctorID
          this.model.PatientReserviedSessionID = this.DoctorRate.PatientReserviedSessionID
      }

        this.$store.dispatch("DoctorList/GetDoctor",  this.model.DoctorID).then(res => {
        this.doctor = res.data.Data;
        this.$vs.loading.close();
      });
  }
};
</script>
<style>
/* .body{
   position: absolute;
      background-image: url(http://doclinia.com/wp-content/uploads/2022/08/4.jpeg);
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
  }
  } */

.back-grewond2 {
  background-image: url("../assets/images/4.png");
  background-repeat: round;
  background-attachment: local;
  background-size: cover;
}
.backgroundimage {
  background-image: url("../assets/images/photo-2.png");
  background-size: cover;
  background-repeat: round;
  background-attachment: local;

  /* background-size: auto;
    background-repeat: no-repeat;
    background-attachment: unset; */
  /* height: 100vh;
  position: relative; */
  /* background-position: center center;
      background-repeat: no-repeat;
      background-size: cover; */

  /* height: auto;
    max-width: 100%; */
}
/* .vs-card--content {
    padding: 0px;
    font-size: .8rem;
    margin-bottom: 15px;
} */
.all-mig {
  width: 50%;
  /* padding: 1%; */
  border-radius: 50% 50% 50% 50%;
}
.con-vs-slider {
  width: 8%;
  /* position: relative; */
  left: 0;
  margin: 16px 0;
  display: block;
  min-width: 7%;
  z-index: 100;
}
.vs-slider--circle {
  width: 0px;
  height: 0px;
  position: fixed;
  top: -6px;
  border-radius: 50%;
  cursor: pointer;
  border: 0;
  margin: 0;
  z-index: 200;
}
.con-slider {
  justify-content: left;
  /* width: 8%; */
  /* position: relative; */
  /* left: 0; */
  margin: 16px 0;
  display: block;
  min-width: 7%;
  z-index: 100;
  /* right: 50px */
}
.con-sliderr {
  /* justify-content: center; */
  /* width: 8%; */
  /* position: relative; */
  /* left: 0; */
  margin: 16px 0;
  display: block;
  min-width: 7%;
  z-index: 100;
  /* right: 50px */
}
.shadow-lg {
  box-shadow: 0 15px 30px 0 rgb(0 0 0 / 62%), 0 5px 15px 0 rgba(0, 0, 0, 0.08) !important;
}
/* .con-vs-slider {
    width: 100%; 
     position: relative; 
    left: 0;
    margin: 16px 0;
    display: block;
    min-width: 5%;
    z-index: 100;
} */
.all-mig { cursor: pointer; }

.home-page-container {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #132953;
  line-height: 1.5;
}

.home-page-container h1,
.home-page-container h2,
.home-page-container h3,
.home-page-container h4,
.home-page-container h5,
.home-page-container h6,
.home-page-container span,
.home-page-container a,
.home-page-container .capitalize-all {
  text-transform: capitalize;
}

.home-page-container h1 {
  font-size: 2.2rem;
  font-weight: 700;
}

.home-page-container h2 {
  font-size: 1.8rem;
  font-weight: 600;
}

.home-page-container h3 {
  font-size: 1.3rem;
  font-weight: 600;
}

.home-page-container h4, 
.home-page-container h5 {
  font-size: 1rem;
  font-weight: 600;
}

.home-page-container .vs-card,
.home-page-container div[style*="background: #fff"],
.home-page-container div[style*="background:#fff"] {
  border-radius: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.home-page-container .vs-col:hover img {
  transform: scale(1.05);
  transition: transform 0.2s ease;
}


.home-page-container .vs-col img[style*="width: 50px"] + h5,
.home-page-container h5[style*="color: aliceblue"] {
  font-size: 0.85rem !important;
  margin-top: 8px;
}

.home-page-container div[style*="background: #fff"],
.home-page-container div[style*="background:#fff"] {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.home-page-container div[style*="background: #fff"]:hover,
.home-page-container div[style*="background:#fff"]:hover {
  transform: translateY(-5px);
}

.shared-footer-wrapper h1,
.shared-footer-wrapper h2,
.shared-footer-wrapper h3,
.shared-footer-wrapper h4,
.shared-footer-wrapper h5,
.shared-footer-wrapper h6,
.shared-footer-wrapper a,
.shared-footer-wrapper span,
.shared-footer-wrapper p {
  text-transform: capitalize !important;
}



.shared-footer-wrapper {
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: Arial, Helvetica, sans-serif;
}

.footer-card-custom {
  width: 100% !important;
  box-shadow: none !important;
  background: transparent !important;
  margin: 0 !important;
  border-radius: 0 !important;
}

.back-grewond2 {
  width: 100%;
  background-color: #19335e;
  background-image: url("../assets/images/4.png");
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: cover;
  padding: 48px 20px 32px;
  box-sizing: border-box;
}

.footer-col-custom {
  padding: 2% !important;
}

.footer-content-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.footer-logo {
  display: block;
  width: 215px;
  max-width: 100%;
  height: auto;
  margin-bottom: 18px;
}

.brand-text {
  margin-bottom: 25px;
}

.brand-text p {
  margin: 0 0 5px;
  font-size: 15px;
  line-height: 1.5;
  color: #ffffff;
}

.brand-text a {
  color: #ffffff;
  font-size: 15px;
  text-decoration: none;
  transition: 0.2s ease;
}

.brand-text a:hover {
  color: #00d633;
}

.contact-area {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 25px;
  width: 100%;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 15px;
  color: #ffffff;
  font-size: 15px;
  text-decoration: none;
  transition: 0.2s ease;
}

.contact-item img {
  width: 27px;
  height: 27px;
  object-fit: contain;
}

.contact-item:hover {
  color: #00d633;
}

.footer-section-title {
  margin-bottom: 15px;
  width: 100%;
}

.footer-section-title h3,
.follow-us h3 {
  margin: 0;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.25;
  text-align: left;
}

.green-line {
  display: block;
  width: 47px;
  height: 4px;
  background: #00d428;
  margin-top: 12px;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
  width: 100%;
}

.footer-links li {
  margin: 0 0 10px;
}

.footer-links a {
  display: flex;
  align-items: center;
  color: #ffffff;
  text-decoration: none;
  font-size: 15px;
  transition: color 0.2s ease, transform 0.2s ease;
}

.footer-links .arrow {
  display: inline-flex;
  width: 20px;
  margin-right: 3px;
  font-size: 26px;
  font-weight: 300;
  line-height: 16px;
  color: #ffffff;
}

.footer-links a:hover {
  color: #00d428;
  transform: translateX(3px);
}

.payment-logos-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 15px;
}

.payment-img {
  width: 55px;
  height: auto;
  object-fit: contain;
}

.payment-text {
  font-size: 14px;
  line-height: 1.5;
  color: #ffffff;
  margin: 10px 0 20px 0;
}

.follow-us {
  margin-top: 10px;
  width: 100%;
}

.social-icons {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.social-icons a {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: transform 0.2s ease;
}

.social-icons a:hover {
  transform: translateY(-3px);
}

.social-icons img {
  display: block;
  width: 35px;
  height: 35px;
  object-fit: contain;
}

/* Handel Css Page  */
.home-page-container p {
  text-transform: lowercase;
}

.home-page-container p::first-letter {
  text-transform: uppercase;
}
.follow-us h3 {
  margin: 0;

  color: #ffffff;

  font-size: 22px;
  font-weight: 700;

  line-height: 1.25;
}
/* End Css Page  */

/*  */


/* =========================================
   DOCLINIA GOOGLE REVIEWS
========================================= */
.google-reviews-section {
  width: 100%;
  padding: 72px 20px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f6faff 0%, #ffffff 100%);
  border-top: 1px solid #eef3f8;
  border-bottom: 1px solid #eef3f8;
}

.google-reviews-inner {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
}

.google-reviews-loading {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #607086;
}

.google-reviews-loading p {
  margin-top: 14px;
  color: #607086;
  text-transform: none !important;
}

.google-loading-spinner {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 4px solid #e7edf5;
  border-top-color: #00c425;
  animation: googleReviewsSpin 0.8s linear infinite;
}

@keyframes googleReviewsSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.google-reviews-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 45px;
  margin-bottom: 38px;
}

.google-reviews-heading {
  max-width: 690px;
}

.google-reviews-eyebrow {
  display: inline-block;
  margin-bottom: 8px;
  color: #00b924;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 700;
  letter-spacing: 1.1px;
  text-transform: uppercase !important;
}

.home-page-container .google-reviews-heading h2 {
  margin: 0 0 10px;
  color: #132953;
  font-size: 34px;
  line-height: 1.25;
  font-weight: 700;
  text-transform: none;
}

.google-reviews-heading p {
  margin: 0;
  color: #657289;
  font-size: 16px;
  line-height: 1.7;
  text-transform: none !important;
}

.google-overall-card {
  min-width: 315px;
  padding: 22px 25px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e8eef5;
  border-radius: 18px;
  box-shadow: 0 12px 34px rgba(19, 41, 83, 0.09);
  text-decoration: none !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.google-overall-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 17px 42px rgba(19, 41, 83, 0.13);
}

.google-brand-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 11px;
}

.google-brand-letter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #e5eaf0;
  color: #4285f4;
  font-size: 20px;
  font-weight: 800;
  text-transform: none !important;
}

.google-brand-name {
  color: #404b5d;
  font-size: 15px;
  font-weight: 700;
  text-transform: none !important;
}

.google-overall-rating-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.google-overall-rating-number {
  color: #132953;
  font-size: 34px;
  line-height: 1;
  font-weight: 800;
  text-transform: none !important;
}

.google-review-count {
  margin-top: 9px;
  color: #7a8698;
  font-size: 13px;
  text-transform: none !important;
}

.google-overall-link-text {
  display: inline-block;
  margin-top: 10px;
  color: #00a921;
  font-size: 13px;
  font-weight: 700;
  text-transform: none !important;
}

.google-reviews-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
}

.google-review-card {
  min-height: 240px;
  display: flex;
  flex-direction: column;
  padding: 22px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e8eef5;
  border-radius: 18px;
  box-shadow: 0 8px 26px rgba(19, 41, 83, 0.07);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.google-review-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 36px rgba(19, 41, 83, 0.12);
}

.google-review-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.google-review-author {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.google-review-author-link {
  display: flex;
  flex-shrink: 0;
  text-decoration: none;
}

.google-review-author-photo,
.google-review-author-placeholder {
  width: 46px;
  height: 46px;
  flex-shrink: 0;
  border-radius: 50%;
}

.google-review-author-photo {
  display: block;
  object-fit: cover;
  background: #eef3f8;
}

.google-review-author-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #132953;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase !important;
}

.google-review-author-info {
  min-width: 0;
}

.home-page-container .google-review-author-info h4 {
  margin: 0 0 3px;
  overflow: hidden;
  color: #132953;
  font-size: 15px;
  line-height: 1.35;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: none;
}

.google-review-author-info span {
  color: #8b96a6;
  font-size: 12px;
  text-transform: none !important;
}

.google-review-source {
  flex-shrink: 0;
  color: #4285f4;
  font-size: 12px;
  font-weight: 700;
  text-transform: none !important;
}

.google-review-stars {
  min-height: 24px;
}

.google-review-text {
  flex: 1;
  margin: 14px 0 0;
  color: #536076;
  font-size: 14px;
  line-height: 1.7;
  text-transform: none !important;
}

.google-review-text::first-letter {
  text-transform: none !important;
}

.google-review-read-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  margin-top: 16px;
  color: #00a921 !important;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none !important;
  text-transform: none !important;
}

.google-review-read-link:hover {
  text-decoration: underline !important;
}

.google-no-review-cards {
  padding: 26px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e8eef5;
  border-radius: 18px;
}

.google-no-review-cards p {
  margin: 0;
  color: #657289;
  text-transform: none !important;
}

.google-reviews-footer {
  margin-top: 34px;
  text-align: center;
}

.google-reviews-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  padding: 0 27px;
  background: #00c425;
  border-radius: 25px;
  box-shadow: 0 8px 22px rgba(0, 196, 37, 0.2);
  color: #ffffff !important;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none !important;
  text-transform: none !important;
  transition: transform 0.2s ease, background 0.2s ease;
}

.google-reviews-button:hover {
  background: #00ad21;
  transform: translateY(-2px);
}

@media (max-width: 991px) {
  .google-reviews-section {
    padding: 58px 18px;
  }

  .google-reviews-header {
    flex-direction: column;
    align-items: stretch;
    gap: 25px;
  }

  .google-overall-card {
    width: 100%;
    min-width: 0;
  }

  .google-reviews-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 650px) {
  .google-reviews-section {
    padding: 44px 14px;
  }

  .home-page-container .google-reviews-heading h2 {
    font-size: 27px;
  }

  .google-reviews-grid {
    grid-template-columns: 1fr;
  }

  .google-review-card {
    min-height: 0;
  }

  .google-overall-rating-row {
    flex-wrap: wrap;
  }
}

</style>

<style scoped>
.home-welcome { background: linear-gradient(135deg, #f5faf7, #f4f7fb); padding: 0 24px 24px; }
.home-intro-row { display: grid; grid-template-columns: .95fr 1.05fr; align-items: center; gap: 44px; max-width: 1320px; margin: 0 auto; padding: 36px 0 54px; }
.home-intro-copy { min-width: 0; }
.home-page-container .home-kicker { display: block; font-size: 11px; font-weight: 700; letter-spacing: 1.6px; color: #168348; text-transform: uppercase; }
.home-page-container #home-title { font-size: clamp(30px, 3vw, 44px); line-height: 1.16; letter-spacing: -1px; margin: 14px 0 16px; color: #132953; text-transform: none; }
#home-title em { color: #168348; font-style: normal; }
.home-page-container .home-lead { font-size: 15px; line-height: 1.7; margin: 0; max-width: 490px; color: #637087; text-transform: none; }
.home-trust-list { display: flex; flex-wrap: wrap; gap: 12px 20px; margin: 22px 0 0; padding: 0; list-style: none; }
.home-trust-list li { display: flex; align-items: center; gap: 7px; font-size: 12px; color: #455a72; }
.home-trust-list .feather-icon { width: 16px; height: 16px; color: #168348; }
.home-intro-media { min-width: 0; overflow: hidden; border-radius: 20px; border: 1px solid #e1e9e5; background: white; box-shadow: 0 12px 32px rgba(19,41,83,.07); }
.home-intro-image { display: block; width: 100%; height: auto; object-fit: contain; }
.home-image-note { display: flex; align-items: center; gap: 10px; padding: 12px 18px; color: #52647b; }
.home-page-container .home-image-note span { font-size: 12px; text-transform: none; }
.home-image-note .feather-icon { width: 17px; height: 17px; color: #168348; }
.home-search-placement { position: relative; max-width: 1320px; margin: -24px auto 0; box-sizing: border-box; }
@media (max-width: 900px) { .home-intro-row { gap: 24px; } .home-welcome { padding-inline: 20px; } }
@media (max-width: 700px) { .home-intro-row { grid-template-columns: 1fr; padding: 24px 0 18px; gap: 20px; } .home-search-placement { margin-top: 0; } .home-welcome { padding: 0 14px 18px; } .home-trust-list { margin-top: 16px; } }
</style>
